export default "__VITE_ASSET__DkGn77NK__"